export const getImageSizeFromURL = async (url: string) => {
  const res = await fetch(url, { mode: 'cors', cache: 'no-cache' });
  if (!res.ok) throw new Error(`Download failed: ${res.status}`);
  return res.headers.get('content-length');
};
